module.exports = __webpack_public_path__ + "static/media/196.25f31631.jpg";